import styled from 'styled-components';
import { BREAKPOINTS } from "../../../../app/appConstants";

export const AccountStyled = styled.div`
    min-height: 100vh;

    display: flex;
    flex-direction: column;

    > h3 {
        padding: 8px 16px;
    }
`;

export const AccountHeaderStyled = styled.div`
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: var(--app-bg-header-color);
`;

export const AccountHeaderBonusContainer = styled.div`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
`;

export const AccountHeaderLogoStyled = styled.div`
    padding: ${({ isSmallMaxWidth }) => isSmallMaxWidth
        ? '16px'
        : '16px 24px'};
`;

export const AccountHeaderMenuStyled = styled.div`
    text-align: right;
    padding: 8px 24px 8px;

    display: flex;
    flex-direction: row;
    align-items: center;
    
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding-right: 16px;
    }
    button, button:hover, button:focus {
        line-height: 20px;
        border: none;
    }
`;

export const AccountContentStyled = styled.div`
    flex: 1 0 auto;

    display: flex;
    flex-direction: row;

    background: var(--dx-bg-color);
`;

export const AccountInfoStyled = styled.div`
    padding: 24px;
`;

export const AccountZendeskButtonWrapper = styled.div`
    margin-left: 30px;
    margin-right: 20px;
`;

export const AccountDividerStyled = styled.hr`
    background: var(--color-surface);
    opacity: 1;
    margin: 16px -16px;
`;
